import {MESSAGE_DATA} from "../../actions/actionTypes";

export function messageReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case MESSAGE_DATA:
            return action.messageData;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/common/messageReducer.js